import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../../../lib/supabase';
import { useAuth } from '../../../contexts/AuthContext';
import { isSuperadminRole } from '../../../domain/superadmin/guards';

/**
 * UX only — NÃO autoriza dados.
 * A autorização real é assertSuperadmin nas Edge Functions.
 * Alterar este estado no DevTools não concede acesso às APIs admin.
 */
export function useIsSuperadmin() {
  const { user } = useAuth();
  const [globalRole, setGlobalRole] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const load = useCallback(async () => {
    if (!user?.id) {
      setGlobalRole(null);
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    const { data, error } = await supabase
      .from('profiles')
      .select('global_role')
      .eq('id', user.id)
      .maybeSingle();
    if (error) {
      console.error('[useIsSuperadmin]', error.message);
      setGlobalRole(null);
    } else {
      setGlobalRole((data?.global_role as string | null) ?? null);
    }
    setIsLoading(false);
  }, [user?.id]);

  useEffect(() => {
    void load();
  }, [load]);

  return {
    isSuperadmin: isSuperadminRole(globalRole),
    isLoading,
    globalRole,
    refetch: load,
  };
}
